import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-star-svg-icon',
    templateUrl: 'duotone-star-svg-icon.component.html',
    standalone: false
})

export class DuotoneStarSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
